export enum MarketAttribute {
    main = 'preselected'
}

export enum OfferState {
    prematch = 'prematch',
    live = 'live'
}

export enum MatchTags {
    superLive = 'superLive'
}
